<div class="order_item_wrapper">

	<div class="max-w-[220px] order_item_wrapper" *ngIf="product.productGroup !=='swatch'">
		<div class="cursor-pointer" (click)="navigate(product)">
			<img src="{{product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.heroImage : product.customization.fabricProductPreview!.product.heroImage}}"
				 class="rounded-md"
				 alt="preview item"/>
		</div>
		<div class="">
			<p class=""
			   [innerHTML]="(product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:30">
			</p>
			<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>

			<p *ngIf="product.customization.selectedFabric" class="price">Fabric : {{ product.customization.selectedFabric.product.sku }}</p>

			<p *ngIf="product.customization.selectedSizeOption" class="price">

				{{ product.customization.sizeDisplayName ? product.customization.sizeDisplayName : 'Size:' }}

				{{ product.customization.selectedSizeOption.label }}
			</p>

			<p *ngIf="product.customization.customSize" class="price">


				{{ prepareCustomSizeLabel(product.customization.customSize) }}</p>

			<p *ngIf="product.customization.selectedFinishList && product.customization.selectedFinishList.length" class="price">

				{{ product.customization.finishDisplayName ? product.customization.finishDisplayName : 'Finish:' }}
				{{ prepareFinishLabel(product.customization.selectedFinishList) }}.</p>
		</div>
	</div>

	<ng-container *ngIf="product.productGroup =='swatch'">

		<div (click)="navigate(product)" class="custom-border"
			 *ngIf="inStockOrederItem.length>0 && product.customization"
			 style="background: url({{product.customization.finishedProductPreview ? product.customization.finishedProductPreview!.product.heroImage : product.customization.fabricProductPreview!.product.heroImage}})">
		</div>

		<div class="">
			<p class="item_name"
			   [innerHTML]="(product.customization.finishedProductPreview ? product.customization.finishedProductPreview.product.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:30">
			</p>
			<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>

			<p *ngIf="product.customization.selectedFabric" class="price">Fabric : {{ product.customization.selectedFabric.product.sku }}</p>

			<p *ngIf="product.customization.selectedSizeOption" class="price">

				{{ product.customization.sizeDisplayName ? product.customization.sizeDisplayName : 'Size:' }}
				{{ product.customization.selectedSizeOption.label }}</p>

			<p *ngIf="product.customization.customSize" class="price">


				{{ prepareCustomSizeLabel(product.customization.customSize) }}</p>

			<p *ngIf="product.customization.selectedFinishList && product.customization.selectedFinishList.length" class="price">
				Finish: {{ prepareFinishLabel(product.customization.selectedFinishList) }}.</p>
		</div>

	</ng-container>

	<button *ngIf="product.orderStatus === 'IN_TRANSIT'"
			class="w-full max-w-[220px] bg-[#fffcf7] rounded border-2 border-[#8E7862] text-[#8E7862] py-1 px-3 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm"
			type="submit"
			(click)="onAddReview()">
		<span>{{ product.reviewId && product.reviewId != 0 ? 'Edit' : 'Add' }}</span> Review
	</button>
</div>



